import { generatorProcessAxiosErrorInQuery } from "@becon-team/becon-fe-lib/my-axios";
import { beconLog } from "@becon-team/becon-fe-lib/utils";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { TIMEOUT } from "../axiosInstance";

import type { AxiosError } from "axios";
import { projectConfig } from "projectConfig";
import { localStorageKeyToken } from "utils/(localStorage)";
import { postBeconLog, postReportToSlack } from "modules/becon/services/becon.handler";

const processAxiosErrorInQuery = generatorProcessAxiosErrorInQuery({
  kind: projectConfig.project.kind,
  postBeconLog,
  postReportToSlack,
  localStorageKeyToken,
});

// *정책: rtt가 15초 초과일 때 1번 재요청
const onRetry = (failureCount: number, error: AxiosError) => {
  if (error.code === "ECONNABORTED" && failureCount < 1) {
    beconLog.ROUNDTRIP_SLOW({
      kind: projectConfig.project.kind,
      status: "fail",
      message: `>${TIMEOUT}ms(x${failureCount + 1})\n- [message] ${error.message}`,
      config: error.config,
      localStorageKeyToken,
    });
    return true;
  }
  return false;
};

const generateQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: onRetry,
        staleTime: 14 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: onRetry,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query.meta?.ignoreError) return;
        processAxiosErrorInQuery(error, query.meta?.errorCodeMap);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        processAxiosErrorInQuery(error, mutation.meta?.errorCodeMap);
      },
    }),
  });
};

export const queryClient = generateQueryClient();
